import i18n from 'i18next';

export const selectModalVisibility = (state) => state.subscriptionPackagesReducer.get('modalContactFormVisible', false);
export const selectRequestedPackageType = (state) => state.subscriptionPackagesReducer.get('requestedPackageType', i18n.t('subPackage freePackage packageType'));
export const selectContactUsFormStateChange = (state) => state.subscriptionPackagesReducer.get('resetContactUsFormData', false);
